import {
  AppScope,
  AuthorizationRole,
  isAppScope,
  isAuthorizationRole,
} from '../../utils/authorizationModel'
import { AuthorizationActionTypes, AuthorizationSource } from './reducer'

export interface RawAuthorizationClaims {
  source: AuthorizationSource
  partnerId?: string | null
  partnerUserId?: string | null
  roles?: string[] | null
  scopes?: string[] | null
  isAuthenticated?: boolean
  claimsLoaded?: boolean
}

const normalizeRoles = (roles?: string[] | null): AuthorizationRole[] =>
  (roles || []).filter(isAuthorizationRole)

const normalizeScopes = (scopes?: string[] | null): AppScope[] =>
  (scopes || []).filter(isAppScope)

export const hydrateAuthorizationClaims = (claims: RawAuthorizationClaims) => ({
  type: AuthorizationActionTypes.HYDRATE_AUTHORIZATION as const,
  payload: {
    source: claims.source,
    partnerId: claims.partnerId ?? null,
    partnerUserId: claims.partnerUserId ?? null,
    roles: normalizeRoles(claims.roles),
    scopes: normalizeScopes(claims.scopes),
    isAuthenticated: claims.isAuthenticated ?? true,
    claimsLoaded: claims.claimsLoaded ?? true,
  },
})

export const clearAuthorizationClaims = () => ({
  type: AuthorizationActionTypes.CLEAR_AUTHORIZATION as const,
})

export const setPolicyReady = () => ({
  type: AuthorizationActionTypes.SET_POLICY_LOAD_STATE as const,
  payload: {
    policyLoadStatus: 'ready' as const,
    policyLoadError: null,
  },
})

export const setPolicyIdle = () => ({
  type: AuthorizationActionTypes.SET_POLICY_LOAD_STATE as const,
  payload: {
    policyLoadStatus: 'idle' as const,
    policyLoadError: null,
  },
})

export const setPolicyLoading = () => ({
  type: AuthorizationActionTypes.SET_POLICY_LOAD_STATE as const,
  payload: {
    policyLoadStatus: 'loading' as const,
    policyLoadError: null,
  },
})

export const setPolicyError = (error: string | null) => ({
  type: AuthorizationActionTypes.SET_POLICY_LOAD_STATE as const,
  payload: {
    policyLoadStatus: error ? 'error' : 'idle',
    policyLoadError: error,
  },
})
